// PDP-07 — Filtre des avis par taille achetée. Voir SHOPIFY.md.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-reviews-filters]').forEach((filterBar) => {
    const list = filterBar.parentElement.querySelector('[data-reviews-list]');
    if (!list) return;

    filterBar.addEventListener('click', (event) => {
      const button = event.target.closest('[data-filter-value]');
      if (!button) return;

      filterBar
        .querySelectorAll('[data-filter-value]')
        .forEach((btn) => btn.setAttribute('aria-pressed', btn === button));

      const value = button.dataset.filterValue;
      list.querySelectorAll('[data-size]').forEach((item) => {
        item.hidden = value !== 'all' && item.dataset.size !== value;
      });
    });
  });
});
